export const ALERTS_UPDATE_ORDERS_PAGE_LEFT_NAV = 'ALERTS_UPDATE_ORDERS_PAGE_LEFT_NAV';
export const updateOrdersPageLeftNav = () => ({
  type: ALERTS_UPDATE_ORDERS_PAGE_LEFT_NAV,
});
